export const AlertMessages = {
  VoyageData: {
    remaining_distance_deviation:
      "The entered remaining distance (${field_value} nm) is ${limit} ${field_name} than the expected value based on the last report."
  },
  VesselReporting: {
    reporting_time_utc:
      "${field_name}\n\n" +
      "${field_value} have elapsed since the last vessel report.\n" +
      "Normal reporting interval : (${limit})\n\n" +
      "Please confirm the timing.",
    distance_travelled_position_coordindates:
      "${field_name} : The value (${field_value}) entered seems to be less than the actual geometric distance between positions. Please verify. \n Acceptable range : (${limit})",
    distance_travelled_speed_time:
      "${field_name} : The value (${field_value}) appears impractical based on the vessel's configured speed and elapsed time since the last report. Please confirm with a valid explanation. \n Acceptable range : (${limit})",
    load_condition_changed_without_operation:
      "${field_name} has been changed to (${field_value}) without a corresponding cargo operation. Please confirm and provide a valid reason.\nPrevious Vessel load condition : (${limit})"
  },
  CpWarranties: {
    ordered_fuel_oil_consumption_gt_3:
      "${field_name} : The consumption rate (${field_value}) is higher than the acceptable average range. \n Acceptable range : (${limit})",
    ordered_fuel_oil_consumption_lt_3:
      "${field_name} : The consumption rate (${field_value}) is lower than the acceptable average range. \n Acceptable range : (${limit})",
  },
  CargoDetails: {
    amount_of_cargo_discharged:
      "${field_name} : The quantity of cargo discharged (${field_value}) exceeds the last reported onboard quantity. \n Acceptable range : (${limit})",
    total_amount_of_cargo_onboard:
      "${field_name} : The reported cargo quantity (${field_value}) is not consistent with previous reports. \n Acceptable range : (${limit})",
  },
  MachineryData: {
    set_rpm_above_mcr:
      "(${field_name}): The entered value (${field_value}) exceeds the MCR rating (${limit}). Please verify and provide a valid reason.\nAcceptable range : (less than or equal to ${limit})",
    avg_rpm_above_mcr:
      "(${field_name}): The average RPM value (${field_value}) exceeds the MCR rating (${limit}). Please verify and provide a valid reason.\nAcceptable range : (less than or equal to ${limit})",
    total_revolutions_above_mcr_capacity:
      "(${field_name}): The total revolutions (${field_value}) exceed the MCR capacity of the engine (${limit}). Please verify and provide a valid reason.\nAcceptable range : (less than or equal to ${limit})",
  },
  EnergyParameter: {
    expected_power:
      "${field_name} : The developed energy (${field_value}) deviates from the average expected value. \n Acceptable range : (${limit})",
  },
  WeatherData: {
    high_weather_data_alert_msg:
      "${field_name} : The value (${field_value}) indicates abnormal weather conditions. Please reconfirm. \n Acceptable range : (${limit})",
    normal_wind_speed_alert_msg:
      "${field_name} : The value (${field_value}) indicates rough weather. Please reconfirm. \n Acceptable range : (${limit})",
    normal_weather_data_alert_msg:
      "${field_name} : The value (${field_value}) indicates unusual weather behavior. Please reconfirm. \n Acceptable range : (${limit})",
    weather_data_barometric_pressure_alert_msg:
      "${field_name} : The barometric pressure value (${field_value}) appears out of the practicable range. Please recheck. \n Acceptable range : (${limit})",
  },
  FuelConsumption: {
    five_per_more:
      "${field_name} : The provided value (${field_value}) is slightly above the average consumption rate. Kindly review and confirm. \n Acceptable range : (${limit})",

    ten_per_more:
      "${field_name} : The provided value (${field_value}) exceeds the acceptable rate of consumption. Kindly review and confirm. \n Acceptable range : (${limit})",
  },
  Bunkering: {
    sulphur_percentage_high_lsfo:
      "${field_name} (${field_value}%) exceeds the allowed sulphur limit for VLSFO. \n Acceptable range : (≤ ${limit}%)",

    sulphur_percentage_high_hsfo:
      "${field_name} (${field_value}%) exceeds the allowed sulphur limit for HSFO. \n Acceptable range : (≤ ${limit}%)",
  },
};

export const getAlertMessage = <
  Section extends keyof typeof AlertMessages,
  FieldKey extends keyof (typeof AlertMessages)[Section]
>(
  section: Section,
  fieldKey: FieldKey,
  fieldName?: string,
  fieldValue?: number | string,
  limit?: number | string
): string => {
  const sectionObj = AlertMessages[section];
  const messageTemplate = sectionObj[fieldKey];

  if (typeof messageTemplate !== "string") {
    return "Unexpected alert condition detected. Please verify your input.";
  }

  let message = messageTemplate as string;

  message = message.replace(/\$\{field_name\}/g, String(fieldName ?? ""));
  message = message.replace(/\$\{field_value\}/g, String(fieldValue ?? ""));
  message = message.replace(/\$\{limit\}/g, String(limit ?? "limit not specified"));

  return message;
};

